import type { FC, SVGProps } from 'react'

export const AutoEq: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.8003 7.08374C15.6696 4.98079 18.5523 4.09034 21.282 4.77276C21.6838 4.87322 21.9281 5.28042 21.8277 5.68226C21.7272 6.08411 21.32 6.32843 20.9182 6.22797C18.7303 5.681 16.4197 6.39471 14.9214 8.08028L14.0508 9.05974C13.5416 9.63251 12.6432 9.62156 12.1482 9.03654C10.1054 6.62232 6.24977 7.13113 4.90318 9.99263L4.27868 11.3197C4.1023 11.6945 3.6555 11.8553 3.28071 11.679C2.90593 11.5026 2.74508 11.0558 2.92145 10.681L3.54596 9.35393C5.31807 5.58819 10.32 4.85099 13.1098 7.86048L13.8003 7.08374Z"
      fill="currentColor"
      fillOpacity="0.7"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.10001 14.25C5.51422 14.25 5.85001 14.5858 5.85001 15L5.85001 17C5.85001 17.4142 5.51422 17.75 5.10001 17.75C4.68579 17.75 4.35001 17.4142 4.35001 17L4.35001 15C4.35001 14.5858 4.68579 14.25 5.10001 14.25Z"
      fill="currentColor"
      fillOpacity="0.4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.10001 10.75C8.51422 10.75 8.85001 11.0858 8.85001 11.5L8.85001 17C8.85001 17.4142 8.51422 17.75 8.10001 17.75C7.68579 17.75 7.35001 17.4142 7.35001 17L7.35001 11.5C7.35001 11.0858 7.68579 10.75 8.10001 10.75Z"
      fill="currentColor"
      fillOpacity="0.4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.1 11.75C11.5142 11.75 11.85 12.0858 11.85 12.5L11.85 17C11.85 17.4142 11.5142 17.75 11.1 17.75C10.6858 17.75 10.35 17.4142 10.35 17L10.35 12.5C10.35 12.0858 10.6858 11.75 11.1 11.75Z"
      fill="currentColor"
      fillOpacity="0.4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.1 12.25C14.5142 12.25 14.85 12.5858 14.85 13L14.85 17C14.85 17.4142 14.5142 17.75 14.1 17.75C13.6858 17.75 13.35 17.4142 13.35 17L13.35 13C13.35 12.5858 13.6858 12.25 14.1 12.25Z"
      fill="currentColor"
      fillOpacity="0.4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.1 10.25C17.5142 10.25 17.85 10.5858 17.85 11L17.85 17C17.85 17.4142 17.5142 17.75 17.1 17.75C16.6858 17.75 16.35 17.4142 16.35 17L16.35 11C16.35 10.5858 16.6858 10.25 17.1 10.25Z"
      fill="currentColor"
      fillOpacity="0.4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.1 9.25C20.5142 9.25 20.85 9.58579 20.85 10L20.85 17C20.85 17.4142 20.5142 17.75 20.1 17.75C19.6858 17.75 19.35 17.4142 19.35 17L19.35 10C19.35 9.58579 19.6858 9.25 20.1 9.25Z"
      fill="currentColor"
      fillOpacity="0.4"
    />
  </svg>
)
